import { render } from "./testingMethod.vue?vue&type=template&id=0b2d1cf2"
import script from "./testingMethod.vue?vue&type=script&lang=js"
export * from "./testingMethod.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__